import React from "react";
import { Reveal } from "../hooks/useReveal";

// Lion crest divider mark
export function CrestMark({ className = "" }) {
  return (
    <div className={`gold-divider ${className}`}>
      <span className="w-1.5 h-1.5 rotate-45 bg-nala-gold inline-block" />
    </div>
  );
}

export default function SectionHeading({ eyebrow, title, subtitle, center = true, light = false }) {
  return (
    <Reveal className={center ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      {eyebrow && (
        <p className="text-nala-gold text-xs md:text-sm tracking-luxe uppercase mb-4 font-medium">
          {eyebrow}
        </p>
      )}
      <h2 className={`font-display text-3xl md:text-5xl leading-[1.1] ${light ? "text-nala-cream" : "text-gold-gradient"}`}>
        {title}
      </h2>
      <div className={center ? "mt-6" : "mt-6"}>
        <CrestMark className={center ? "" : "!justify-start"} />
      </div>
      {subtitle && (
        <p className="mt-6 text-nala-cream-muted font-serif-lux text-lg md:text-xl leading-relaxed">
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}
